export enum TypOdbiorcy {
  Uzytkownik = 1,
  GrupaOdbiorcow,
}
